import styled from 'styled-components';
const percentageSize = 1.3;

export const ExportBtnIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 512 512',
  width: props.fontSizeEnabled ? 26 * percentageSize : 26,
  height: props.fontSizeEnabled ? 26 * percentageSize : 26
}))``;

export const TransparencyBtnIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  viewBox: '0 0 24 24',
  width: props.fontSizeEnabled ? 27 * percentageSize : 27,
  height: props.fontSizeEnabled ? 27 * percentageSize : 27
}))``;

export const InfoBtnIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 512 512',
  width: props.fontSizeEnabled ? 26 * percentageSize : 26,
  height: props.fontSizeEnabled ? 26 * percentageSize : 26
}))``;

export const InfoDisabledBtnIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 512 512',
  width: props.fontSizeEnabled ? 26 * percentageSize : 26,
  height: props.fontSizeEnabled ? 26 * percentageSize : 26
}))``;

export const MetadataBtnIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  viewBox: '0 0 512 512',
  id: 'MD',
  width: props.fontSizeEnabled ? 24 * percentageSize : 24,
  height: props.fontSizeEnabled ? 24 * percentageSize : 24
}))``;

export const CloseBtnIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  width: props.fontSizeEnabled ? 24 * percentageSize : 24,
  height: props.fontSizeEnabled ? 24 * percentageSize : 24
}))``;

export const AddElementBtnIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  width: props.fontSizeEnabled ? 24 * percentageSize : 24,
  height: props.fontSizeEnabled ? 24 * percentageSize : 24
}))``;

export const ExportFormatBtnIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  viewBox: '0 0 512 512',
  width: props.fontSizeEnabled ? 24 * percentageSize : 24,
  height: props.fontSizeEnabled ? 24 * percentageSize : 24
}))``;

export const StylesBtnIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 512 512',
  width: props.fontSizeEnabled ? 24 * percentageSize : 24,
  height: props.fontSizeEnabled ? 24 * percentageSize : 24
}))``;

export const FilterBtnIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 24 24',
  width: props.fontSizeEnabled ? 24 * percentageSize : 24,
  height: props.fontSizeEnabled ? 24 * percentageSize : 24
}))``;

export const TableBtnIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 24 24',
  width: props.fontSizeEnabled ? 25 * percentageSize : 25,
  height: props.fontSizeEnabled ? 25 * percentageSize : 25
}))``;

export const StatsBtnIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 512 512',
  width: props.fontSizeEnabled ? 24 * percentageSize : 24,
  height: props.fontSizeEnabled ? 23 * percentageSize : 23
}))``;

export const ZoomBtnIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  viewBox: '0 0 512 512',
  width: props.fontSizeEnabled ? 24 * percentageSize : 24,
  height: props.fontSizeEnabled ? 24 * percentageSize : 24,
  fill: !props.layer.isExternal()
    ? window.innerWidth > 768
      ? props.isZoomToLayerHover
        ? '#febf00'
        : 'white'
      : props.movilZoomHover
      ? '#febf00'
      : 'white'
    : '#666666'
}))``;
